import {
  useAppDispatch,
  useAppSelector,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import useScrollBlocker from "./useScrollBlocker";
import useMediaQuery from "@/utils/hooks/useMediaQuery";
import {
  createRecipeToListAction,
  getRecipeListAction,
} from "@/utils/redux/recipes/addtolistSlice/actions";
import { getfetchFavouritesRecipes } from "@/utils/redux/recipes/recipeSlice/actions";
import { setToastMessage } from "@/utils/redux/recipes/toastMessageSlice";
import useNetwork from "./useNetwork";
import { addRecipeToListDataLeyarFun } from "./dataLayer";
import { useGigyaToken } from "./getGigyaToken";

const useCreateList = ({
  closeFavModal,
  componentName,
  closePreviousModal,
  favouriteOpen = false,
  addRecipeToList,
  selectedRecipeList,
  addedRecipetoList,
  recipeByListId,
}: {
  closeFavModal?: any;
  componentName?: string;
  closePreviousModal?: any;
  favouriteOpen?: boolean;
  addRecipeToList?: any;
  selectedRecipeList?: any;
  addedRecipetoList?: any;
  recipeByListId?: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(true);
  const [disableButtonRecipe, setDisableButtonRecipe] = useState<boolean>(true);
  const [isProgressModal, setIsProgressModal] = useState<boolean>(false);
  const [isNewRecipeAdded, setIsNewRecipeAdded] = useState<boolean>(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
  const [disableButtonsFolder, setDisableButtonsFolder] =
    useState<boolean>(true);

  const [recipeListName, setRecipeListName] = useState<string>("");
  const [folderId, setFolderId] = useState<string | null>(null);
  const [search, setSearch] = useState<string>("");

  const [searchRecipeData, setSearchRecipeData] = useState<any[]>([]);
  const [selectRecipe, setSelectRecipe] = useState<any[]>([]);
  const [saveAnywayDisable, setSaveAnywayDisable] = useState<boolean>(false)
  const dispatch = useAppDispatch();
  const { getAccountInfo, resetLoginParams } = useGigyaToken();

  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );
  const isOnline = useNetwork();
  const { bodyRef, enableBackgroundScroll, disableBackgroundScroll } =
    useScrollBlocker();
  const windowWidth = useMediaQuery();
  const isMobile = windowWidth !== null && windowWidth <= 767;
  const isTablet =
    windowWidth !== null && windowWidth >= 768 && windowWidth <= 1199;

  const openModal = () => {
    setDisableButtonsFolder(true);
    if (!Uid) {
      setIsLoginModalOpen(true);
      return;
    }
    setIsEditing(true);
    if (addRecipeToList) {
      setIsEditing(false);
      setDisableButtonsFolder((_prev: boolean) => false); // Enable editing for Add Recipe
      setFolderId(selectedRecipeList.id);
      setRecipeListName(selectedRecipeList.list_name);
      setSelectRecipe(componentName === "favourite" ? [...recipeByListId] : []);
      setIsNewRecipeAdded(
        componentName === "favourite" && recipeByListId.length > 0
      );
      setDisableButtonRecipe(false);
    } else {
      setRecipeListName("");
      setFolderId(null);
      setIsNewRecipeAdded(false);
    }
    if (componentName === "favourite") {
      closePreviousModal();
    }
    setIsModalOpen(true);
  };

  const clearQuery = () => {
    if (!search) return;
    setSearch("");
    setSearchRecipeData([]);
  };

  const closeLoginModal = () => setIsLoginModalOpen(false);

  const closeCreateListModal = () => {
    setIsModalOpen(false);
  };
  const setTheProgressModal = (value: boolean) => {
    setIsProgressModal(value);
  };

  const closeIsProgressModal = () => {
    setSelectRecipe([]);
    setIsProgressModal(false);
    setIsModalOpen(false);
    if (componentName === "favourite") {
      closeFavModal();
    }
    setFolderId(null);
    setSearch("");
    clearQuery();
  };

  const saveRecipesToFolder = async () => {
    /** Check if User is online */

    if (isProgressModal) {
      setSaveAnywayDisable(true);
    }
    if (!isOnline) {
      dispatch(
        setToastMessage({
          message: `${MESSAGE.ERROR_MESSAGE.OFFLINE_ERROR}`,
          status: "",
        })
      );
      return;
    }
    const arrayOfObjects = selectRecipe.map((item: any) => ({
      recipe_id: item.objectID,
      recipe_name: item.title,
      list_id: folderId,
      // user_id: Uid,
      type: "save_list",
    }));

    let filteredArrayOfObjects;

    if (addRecipeToList) {
      const selectedRecipeIds = selectedRecipeList.recipes.map(
        (recipe: any) => recipe.recipe_id
      );
      filteredArrayOfObjects = arrayOfObjects.filter(
        (obj: any) => !selectedRecipeIds.includes(obj.recipe_id)
      );
      addedRecipetoList(selectRecipe);
    } else {
      filteredArrayOfObjects = arrayOfObjects;
    }
    const { idToken: token } = await getAccountInfo();
    const payload ={
      token,
      recipes: filteredArrayOfObjects,
    };
    const result = await dispatch(createRecipeToListAction(payload));
    if (result?.payload?.status == 401) {
      resetLoginParams();
      return;
      // loadLogin("login");
      // dispatch(
      //   setToastMessage({
      //     message: "Session Timeout",
      //     status: "other",
      //   })
      // );
    }
    const datalayer = filteredArrayOfObjects?.map((item, _idx)=>({
      ...item,
      event: "add_recipe_to_list",
      recipe_name: item.recipe_name,
      list_name: "My Recipe List",
      recipe_list_name: recipeListName,
      page_title: document.title,
    }));
    addRecipeToListDataLeyarFun(datalayer);
    const resultList = await dispatch(getRecipeListAction({ token }));
    if (resultList?.payload?.status == 401) {
      resetLoginParams();
      return;
      // dispatch(
      //   setToastMessage({
      //     message: "Session Timeout",
      //     status: "other",
      //   })
      // );
    }
    const resultFav = await dispatch(getfetchFavouritesRecipes({ token }));
    if (resultFav?.payload?.status == 401) {
      resetLoginParams();
      return;
    }
    if (componentName === "favourite") {
      closeFavModal();
    }
    setSelectRecipe([]);
    dispatch(
      setToastMessage({
        message:
          selectRecipe.length == 0
            ? MESSAGE.RECIPE_LIST_CREATE
            : MESSAGE.RECIPE_ADDED_TO_LIST,
        status: "",
      })
    );
    setIsModalOpen(false);
    setFolderId(null);
    setIsProgressModal(false);
    setSearch("");
    setSearchRecipeData([]);
    setDisableButtonsFolder(true);
    setDisableButtonRecipe(true);
    setSaveAnywayDisable(false);
    // Allow Scrolling
    if (componentName === "favourite" || !(isMobile || isTablet)) {
      enableBackgroundScroll();
    }
  };

  return {
    setDisableButtonsFolder,
    Uid,
    setIsLoginModalOpen,
    setIsEditing,
    setFolderId,
    setRecipeListName,
    setSelectRecipe,
    setIsNewRecipeAdded,
    setDisableButtonRecipe,
    setIsModalOpen,
    isModalOpen,
    search,
    setSearch,
    setSearchRecipeData,
    selectRecipe,
    isNewRecipeAdded,
    isProgressModal,
    setIsProgressModal,
    isEditing,
    folderId,
    closeFavModal,
    closePreviousModal,
    favouriteOpen,
    dispatch,
    aemModalData,
    isMobile,
    isTablet,
    disableButtonsFolder,
    recipeListName,
    disableButtonRecipe,
    isLoginModalOpen,
    searchRecipeData,
    clearQuery,
    closeLoginModal,
    closeCreateListModal,
    setTheProgressModal,
    closeIsProgressModal,
    saveRecipesToFolder,
    openModal,
    bodyRef,
    enableBackgroundScroll,
    disableBackgroundScroll,
    saveAnywayDisable
  };
};
export default useCreateList;
